import { createSlice } from "@reduxjs/toolkit";

export const selectedActivity = createSlice({
  name: "selectedActivity",
  initialState: {
    value: {
      status: false,
      data: {},
    },
  },
  reducers: {
    updateSelectedActivity: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateSelectedActivity } = selectedActivity.actions;

export default selectedActivity.reducer;
